module.exports = __webpack_public_path__ + "static/card_homepage_square-f5532d7c2e4ac516010b9637543acabb.jpg";